import { productConfigSchema, type ProductConfigInput } from "./schema.ts"

export class ProductConfigError extends Error {
  readonly issues: readonly string[]

  constructor(issues: readonly string[]) {
    super(`Invalid product config:\n${issues.join("\n")}`)
    this.name = "ProductConfigError"
    this.issues = issues
  }
}

/** Returns `value` unchanged when it passes the schema, otherwise throws every issue at once. */
export function validateProductConfig<T extends ProductConfigInput>(value: T): T {
  const result = productConfigSchema.safeParse(value)
  if (!result.success) {
    throw new ProductConfigError(
      result.error.issues.map((i) => `  ${i.path.join(".") || "(root)"}: ${i.message}`),
    )
  }
  return value
}
